import { TranslatedComponent } from 'bloko/common/hooks/useTranslations';
import { format } from 'bloko/common/trl';

import translation from 'src/components/translation';
import { useSelector } from 'src/hooks/useSelector';

const SHOWING_SETTINGS_COUNT = 3;

const TrlKeys = {
    allVacancies: 'search.vacancy.savedSearch.allVacancies',
    showMore: 'search.vacancy.savedSearch.more',
};

const SavingClusters: TranslatedComponent = ({ trls }) => {
    const criteria = useSelector((state) => state.vacancySearchResult.criteria);
    const usingClusters = useSelector((state) => state.vacancySearchResult.savedSearches.selectedClusters);
    const hiddenClustersCount = usingClusters.length - SHOWING_SETTINGS_COUNT;

    return (
        <>
            <span className="vacancy-serp-subscription-filter-name">
                {criteria?.text || trls[TrlKeys.allVacancies]}
            </span>
            {usingClusters
                .slice(0, hiddenClustersCount > 1 ? SHOWING_SETTINGS_COUNT : usingClusters.length)
                .map((cluster) => (
                    <span key={`${cluster?.name}${cluster?.title}`} className="vacancy-serp-subscription-filter-name">
                        {cluster.title}
                    </span>
                ))}
            {hiddenClustersCount > 1 && (
                <span className="vacancy-serp-subscription-filter-name">
                    {format(trls[TrlKeys.showMore], { '{0}': hiddenClustersCount })}
                </span>
            )}
        </>
    );
};

export default translation(SavingClusters);
